import { useEffect, useState } from "react";
import Button from "../../../componentes/button/button";
import CargaEntregaService from "../../../services/resource/escalaDeRotaService";
import { toast } from "react-toastify";
import EntregaService from "../../../services/resource/entregaService";
import DropDown from "../../../componentes/dropdown/dropdown";
import DateMasked from "../../../componentes/inputMask/DateMasked";

function ImportacaoEscalaDeRota({ onSuccess, filiais, idFilial, perfis }) {

    const cargaService = new CargaEntregaService();
    const entregaService = new EntregaService();

    const [file, setFile] = useState(null);
    const [filialId, setFilialId] = useState(idFilial);
    const [dataOperacao, setDataOperacao] = useState("");
    const [importacaoExistente, setImportacaoExistente] = useState(false);

    const [analisando, setAnalisando] = useState(false);
    const [preview, setPreview] = useState(null);
    const [arquivoAnalisado, setArquivoAnalisado] = useState(null);

    const [loading, setLoading] = useState(false);
    const [importacaoFinalizada, setImportacaoFinalizada] = useState(false);
    const [formKey, setFormKey] = useState(0);

    const [resultadoCarga, setResultadoCarga] = useState(null);
    const [resultadoEntrega, setResultadoEntrega] = useState(null);

    useEffect(() => {
        if (dataOperacao && filialId) {
            cargaService.buscarImportacao({ filialId: filialId, dataOperacao: dataOperacao }).then(res => {
                setImportacaoExistente(res.data)
            }).catch((e) => console.error(e))
        }
    }, [dataOperacao])

    const limparPreview = () => {
        setPreview(null);
        setArquivoAnalisado(null);
    };

    const handleAnalisar = async () => {

        if (!file) {
            toast.warning("Anexe a planilha.");
            return;
        } else if (!filialId) {
            toast.warning("Preencha a Filial");
            return;
        } else if (!dataOperacao) {
            toast.warning("Preencha a Data da Operação");
            return;
        }

        setAnalisando(true);
        setPreview(null);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("filialId", filialId);
        formData.append("dataOperacao", dataOperacao);

        try {
            const res = await cargaService.preVisualizarImportacao(formData);
            setPreview(res.data);
            setArquivoAnalisado({ file, filialId, dataOperacao });
        } catch (e) {
            toast.error(e?.response?.data?.message || "Erro ao analisar a planilha.");
        } finally {
            setAnalisando(false);
        }
    };

    const handleConfirmarImportacao = async () => {
        if (!arquivoAnalisado) return;

        setLoading(true);
        setImportacaoFinalizada(false);
        setResultadoCarga(null);
        setResultadoEntrega(null);

        const formData = new FormData();
        formData.append("file", arquivoAnalisado.file);
        formData.append("filialId", arquivoAnalisado.filialId);
        formData.append("dataOperacao", arquivoAnalisado.dataOperacao);

        try {
            const cargaResponse = await cargaService.importarExcel(formData);
            setResultadoCarga(cargaResponse.data);

            const entregaResponse = await entregaService.importarExcel(formData);
            setResultadoEntrega(entregaResponse.data);

            toast.success("Importação concluída!");
            setImportacaoFinalizada(true);

            onSuccess?.();
            limpaDados();
        } catch (e) {
            toast.error("Erro durante a importação.");
        } finally {
            setFormKey(prev => prev + 1);
            setLoading(false);
            setImportacaoFinalizada(true);
        }
    };

    const limpaDados = () => {
        setFile(null);
        setDataOperacao(null);
        limparPreview();
    };

    const RenderResultado = ({ titulo, resultado }) => {
        if (!resultado) return null;

        const sucesso = resultado.totalIgnoradas === 0 && !resultado.alertas?.length;

        return (
            <div
                className={`
                rounded-3xl border shadow-card overflow-hidden
                ${sucesso
                        ? "border-success/30"
                        : "border-amber-200"}
            `}
            >

                {/* HEADER */}
                <div
                    className={`
                    px-5 py-4 border-b flex items-center justify-between
                    ${sucesso
                            ? "bg-success/10 border-success/20"
                            : "bg-amber-50 border-amber-100"}
                `}
                >
                    <div>
                        <h3 className="text-lg font-semibold font-display text-foreground">
                            {titulo}
                        </h3>

                        <p className="text-sm text-muted-foreground mt-1">
                            Resultado do processamento da planilha
                        </p>
                    </div>

                    <div
                        className={`
                        px-3 py-1 rounded-full text-xs font-semibold
                        ${sucesso
                                ? "bg-success/10 text-success"
                                : "bg-amber-100 text-amber-700"}
                    `}
                    >
                        {sucesso
                            ? "Importação concluída"
                            : "Importação com alertas"}
                    </div>
                </div>

                {/* KPIs */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 p-3">

                    <div className="bg-muted rounded-2xl p-4 border border-border">
                        <p className="text-xs text-muted-foreground uppercase tracking-wide">
                            Processadas
                        </p>

                        <p className="text-3xl font-bold font-display text-foreground mt-2">
                            {resultado.totalProcessadas}
                        </p>
                    </div>

                    <div className="bg-blue-50 rounded-2xl p-4 border border-blue-100">
                        <p className="text-xs text-blue-600 uppercase tracking-wide">
                            Criadas
                        </p>

                        <p className="text-3xl font-bold text-blue-700 mt-2">
                            {resultado.totalCadastradas}
                        </p>
                    </div>

                    <div className="bg-indigo-50 rounded-2xl p-4 border border-indigo-100">
                        <p className="text-xs text-indigo-600 uppercase tracking-wide">
                            Atualizadas
                        </p>

                        <p className="text-3xl font-bold text-indigo-700 mt-2">
                            {resultado.totalAtualizadas}
                        </p>
                    </div>

                    <div className="bg-amber-50 rounded-2xl p-4 border border-amber-100">
                        <p className="text-xs text-amber-700 uppercase tracking-wide">
                            Ignoradas
                        </p>

                        <p className="text-3xl font-bold text-amber-700 mt-2">
                            {resultado.totalIgnoradas}
                        </p>
                    </div>
                </div>

                {/* ALERTAS (ex.: funcionário não localizado) */}
                {resultado.alertas?.length > 0 && (
                    <div className="px-3 pt-3">
                        <div className="border border-amber-200 bg-amber-50 rounded-2xl p-4">

                            <div className="flex items-center gap-2 mb-3">
                                <i className="fa fa-user-times text-amber-600" />

                                <p className="font-semibold text-amber-700">
                                    Avisos ({resultado.alertas.length})
                                </p>
                            </div>

                            <div className="max-h-56 overflow-y-auto space-y-2">
                                {resultado.alertas.map((alerta, index) => (
                                    <div
                                        key={index}
                                        className="
                                        bg-card border border-amber-200
                                        rounded-xl px-3 py-2
                                        text-sm text-foreground
                                    "
                                    >
                                        {alerta}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* ERROS */}
                {resultado.erros?.length > 0 && (
                    <div className="px-3 py-5">
                        <div className="border border-red-100 bg-red-50 rounded-2xl p-4">

                            <div className="flex items-center gap-2 mb-3">
                                <i className="fa fa-exclamation-circle text-red-500" />

                                <p className="font-semibold text-red-700">
                                    Inconsistências encontradas
                                </p>
                            </div>

                            <div className="max-h-56 overflow-y-auto space-y-2">
                                {resultado.erros.map((erro, index) => (
                                    <div
                                        key={index}
                                        className="
                                        bg-card border border-destructive/20
                                        rounded-xl px-3 py-2
                                        text-sm text-foreground
                                    "
                                    >
                                        {erro}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const RenderPreview = ({ preview }) => {
        if (!preview) return null;

        return (
            <div
                className={`
                rounded-3xl border shadow-card overflow-hidden
                ${preview.bloqueado ? "border-destructive/30" : "border-border"}
            `}
            >
                {/* HEADER */}
                <div
                    className={`
                    px-5 py-4 border-b flex items-center justify-between gap-3
                    ${preview.bloqueado ? "bg-destructive/10 border-destructive/20" : "bg-muted border-border"}
                `}
                >
                    <div>
                        <h3 className="text-lg font-semibold font-display text-foreground">
                            Pré-visualização da importação
                        </h3>

                        <p className="text-sm text-muted-foreground mt-1">
                            {preview.filialNome} &middot; {preview.dataOperacao}
                        </p>
                    </div>

                    {!preview.bloqueado && (
                        <div className="px-3 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary whitespace-nowrap">
                            {preview.tipoDetectado}
                        </div>
                    )}
                </div>

                <div className="p-5 space-y-4">

                    {preview.bloqueado ? (
                        <div className="flex items-start gap-3 rounded-2xl border border-destructive/30 bg-destructive/10 p-4">
                            <i className="fa fa-exclamation-triangle text-destructive text-xl mt-1" />

                            <div>
                                <h4 className="font-semibold text-destructive">
                                    Não foi possível ler esta planilha
                                </h4>

                                <p className="text-sm text-foreground mt-1">
                                    {preview.mensagemBloqueio}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <>
                            {preview.camposAusentes?.length > 0 && (
                                <div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4">
                                    <i className="fa fa-exclamation-circle text-amber-600 text-lg mt-1" />

                                    <div>
                                        <h4 className="font-semibold text-amber-700">
                                            Planilha parcialmente editada
                                        </h4>

                                        <p className="text-sm text-foreground mt-1">
                                            Não foram encontradas as colunas: <strong>{preview.camposAusentes.join(", ")}</strong>. Esses campos ficarão em branco nas cargas importadas.
                                        </p>
                                    </div>
                                </div>
                            )}

                            {preview.alertas?.length > 0 && (
                                <details className="rounded-2xl border border-amber-200 bg-amber-50 p-3" open>
                                    <summary className="flex items-center gap-2 text-sm font-semibold text-amber-700 cursor-pointer">
                                        <i className="fa fa-user-times text-amber-600" />
                                        Motorista/auxiliar não localizado ({preview.alertas.length})
                                    </summary>

                                    <p className="text-xs text-muted-foreground mt-2">
                                        O nome digitado na planilha não bate com nenhum funcionário cadastrado. Confira a grafia antes de confirmar, ou continue — a carga será importada sem essa atribuição.
                                    </p>

                                    <div className="mt-2 space-y-1 max-h-40 overflow-y-auto">
                                        {preview.alertas.map((alerta, index) => (
                                            <div key={index} className="text-xs text-foreground bg-card border border-amber-100 rounded-lg px-2 py-1">
                                                {alerta}
                                            </div>
                                        ))}
                                    </div>
                                </details>
                            )}

                            <div className="grid grid-cols-2 gap-2">
                                <div className="bg-success/10 rounded-2xl p-4 border border-success/20">
                                    <p className="text-xs text-success uppercase tracking-wide">
                                        Linhas válidas
                                    </p>

                                    <p className="text-3xl font-bold text-success mt-2">
                                        {preview.totalLinhasValidas}
                                    </p>
                                </div>

                                <div className="bg-amber-50 rounded-2xl p-4 border border-amber-100">
                                    <p className="text-xs text-amber-700 uppercase tracking-wide">
                                        Linhas inválidas
                                    </p>

                                    <p className="text-3xl font-bold text-amber-700 mt-2">
                                        {preview.totalLinhasInvalidas}
                                    </p>
                                </div>
                            </div>

                            {preview.detalhesInvalidas?.length > 0 && (
                                <details className="rounded-2xl border border-border bg-muted p-3">
                                    <summary className="text-sm font-medium text-foreground cursor-pointer">
                                        Ver detalhes das linhas inválidas ({preview.detalhesInvalidas.length})
                                    </summary>

                                    <div className="mt-2 space-y-1 max-h-40 overflow-y-auto">
                                        {preview.detalhesInvalidas.map((detalhe, index) => (
                                            <div key={index} className="text-xs text-muted-foreground">
                                                {detalhe}
                                            </div>
                                        ))}
                                    </div>
                                </details>
                            )}

                            {preview.amostra?.length > 0 && (
                                <div className="overflow-x-auto rounded-2xl border border-border">
                                    <table className="w-full text-xs">
                                        <thead className="bg-muted">
                                            <tr>
                                                <th className="px-3 py-2 text-left">Carga</th>
                                                <th className="px-3 py-2 text-left">Veículo</th>
                                                <th className="px-3 py-2 text-left">Transporte</th>
                                                <th className="px-3 py-2 text-left">Motorista</th>
                                                <th className="px-3 py-2 text-left">Auxiliar 1</th>
                                                <th className="px-3 py-2 text-left">Auxiliar 2</th>
                                                <th className="px-3 py-2 text-left">Área</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {preview.amostra.map((linha, index) => (
                                                <tr key={index} className="border-t border-border">
                                                    <td className="px-3 py-2">{linha.carga}</td>
                                                    <td className="px-3 py-2">{linha.veiculo || "—"}</td>
                                                    <td className="px-3 py-2">{linha.transporte || "—"}</td>
                                                    <td className="px-3 py-2">{linha.motorista || "—"}</td>
                                                    <td className="px-3 py-2">{linha.auxiliar1 || "—"}</td>
                                                    <td className="px-3 py-2">{linha.auxiliar2 || "—"}</td>
                                                    <td className="px-3 py-2">{linha.area || "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    )}

                    <div className="flex justify-end gap-2 pt-2 border-t border-border">
                        <Button
                            variant="gray"
                            label="Escolher outro arquivo"
                            onClick={limparPreview}
                            iconLeft="fa fa-arrow-left"
                        />

                        <Button
                            variant="indigo"
                            label={loading ? "Importando..." : "Confirmar Importação"}
                            loading={loading}
                            disabled={preview.bloqueado || loading}
                            onClick={handleConfirmarImportacao}
                            iconLeft="fa fa-check"
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="flex flex-col lg:flex-row gap-8 py-4">

            {/* LADO ESQUERDO - FORM */}
            <div key={formKey} className="lg:w-1/2 bg-card border border-border rounded-2xl shadow-soft p-6 space-y-5">

                <DropDown
                    label="Filial"
                    name="filialId"
                    options={filiais}
                    optionLabel="nome"
                    optionValue="id"
                    nullValue
                    disabled={perfis.includes('COMISSOES')}
                    filter={false}
                    value={filialId}
                    onChange={(e) => {
                        limparPreview();
                        if (perfis.includes('COMISSOES')) {
                            setFilialId(idFilial);
                        } else {
                            setFilialId(e.target.value)
                        }
                    }}
                />

                <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-foreground">
                        Arquivo de Resumo de Planejamento
                    </label>

                    <label
                        className="
            border-2 border-dashed border-input
            rounded-2xl p-6
            flex flex-col items-center justify-center
            cursor-pointer
            hover:border-primary/50
            hover:bg-primary/5
            transition-all duration-150
        "
                    >
                        <i className="fa fa-file-excel text-3xl text-success mb-2" />

                        <span className="text-sm font-medium text-foreground">
                            Clique para selecionar a planilha
                        </span>

                        <span className="text-xs text-muted-foreground mt-1">
                            Arquivos .xlsx, .xls ou .xlsm
                        </span>

                        {file && (
                            <div className="mt-3 text-sm text-primary font-medium">
                                {file.name}
                            </div>
                        )}

                        <input
                            type="file"
                            accept=".xlsx,.xls,.xlsm"
                            className="hidden"
                            onChange={(e) => {
                                limparPreview();
                                setFile(e.target.files[0]);
                            }}
                        />
                    </label>
                </div>

                <DateMasked
                    type="date"
                    className="rounded-lg"
                    label="Data de Saída"
                    helpText="Data da programação de saída dos veículos"
                    value={dataOperacao}
                    error={importacaoExistente ? "Já houve arquivo importado para este dia!" : null}
                    touched={true}
                    onChange={(e) => {
                        limparPreview();
                        setDataOperacao(e);
                    }}

                />

                <Button
                    onClick={handleAnalisar}
                    disabled={analisando || !file}
                    label={analisando ? "Analisando planilha..." : "Analisar Planilha"}
                    loading={analisando}
                    iconLeft="fa fa-search"
                />
            </div>

            {/* LADO DIREITO - RESULTADOS */}


            <div className="lg:w-2/3 space-y-3">

                {!analisando && !loading && !preview && !importacaoFinalizada && (
                    <div className="
            h-full min-h-[400px]
            flex flex-col items-center justify-center
            text-center
            text-muted-foreground
            border-2 border-dashed border-border
            rounded-2xl
            p-10
            bg-muted
        ">
                        <i className="fa fa-cloud-upload text-5xl mb-4" />

                        <h3 className="text-lg font-semibold text-foreground">
                            Nenhuma importação realizada
                        </h3>

                        <p className="text-sm max-w-sm mt-2">
                            Selecione a planilha e clique em "Analisar Planilha" para
                            conferir os dados antes de confirmar a importação.
                        </p>
                    </div>
                )}

                {analisando && (
                    <div className="
            h-full min-h-[400px]
            flex flex-col items-center justify-center
            text-center
            border border-border rounded-2xl
            bg-card
        ">
                        <i className="fa fa-spinner fa-spin text-4xl text-primary mb-4" />

                        <h3 className="text-lg font-semibold text-foreground">
                            Analisando planilha...
                        </h3>

                        <p className="text-sm text-muted-foreground mt-2">
                            Identificando o tipo de planilha e validando as linhas.
                        </p>
                    </div>
                )}

                {loading && (
                    <div className="
            h-full min-h-[400px]
            flex flex-col items-center justify-center
            text-center
            border border-border rounded-2xl
            bg-card
        ">
                        <i className="fa fa-spinner fa-spin text-4xl text-primary mb-4" />

                        <h3 className="text-lg font-semibold text-foreground">
                            Processando importação...
                        </h3>

                        <p className="text-sm text-muted-foreground mt-2">
                            Aguarde enquanto os dados são importados.
                        </p>
                    </div>
                )}

                {!loading && !importacaoFinalizada && preview && (
                    <RenderPreview preview={preview} />
                )}

                {importacaoFinalizada && resultadoCarga && (
                    <RenderResultado
                        titulo="Resultado Importação de Cargas"
                        resultado={resultadoCarga}
                    />
                )}
            </div>
        </div>
    );
}

export default ImportacaoEscalaDeRota;
